import { render, staticRenderFns } from "./SystemProfile.vue?vue&type=template&id=6245b27c&"
import script from "./SystemProfile.vue?vue&type=script&lang=js&"
export * from "./SystemProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports